var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchedulerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.756757 7C0.756757 3.54095 3.63666 0.736842 7.18919 0.736842C9.48683 0.736842 11.4664 1.9103 12.5978 3.68129L10.5957 3.67558C10.3867 3.67498 10.2168 3.83944 10.2162 4.04292C10.2156 4.24639 10.3845 4.41182 10.5935 4.41242L13.2125 4.41989C13.2323 4.42148 13.2523 4.42156 13.2724 4.42006L13.6205 4.42105C13.7211 4.42134 13.8176 4.38265 13.8888 4.31353C13.96 4.2444 14 4.15053 14 4.05263L14 1.10526C14 0.90179 13.8306 0.736842 13.6216 0.736842C13.4126 0.736842 13.2432 0.90179 13.2432 1.10526L13.2432 3.29673C11.982 1.31964 9.76614 0 7.18919 0C3.21871 0 0 3.13401 0 7C0 10.866 3.21871 14 7.18919 14C10.0156 14 12.4076 12.4125 13.5821 10.1113C13.6751 9.92911 13.5988 9.70799 13.4116 9.61744C13.2245 9.52689 12.9974 9.6012 12.9044 9.78341C11.85 11.8494 9.71116 13.2632 7.18919 13.2632C3.63666 13.2632 0.756757 10.459 0.756757 7Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.18919 3.68421C7.39816 3.68421 7.56757 3.84916 7.56757 4.05263V6.69479C7.56757 6.7925 7.60743 6.88621 7.67839 6.9553L8.97026 8.21317C9.11802 8.35705 9.11802 8.59032 8.97026 8.7342C8.82249 8.87808 8.58292 8.87808 8.43515 8.7342L7.14328 7.47633C6.93041 7.26905 6.81081 6.98792 6.81081 6.69479V4.05263C6.81081 3.84916 6.98022 3.68421 7.18919 3.68421Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulerIcon);
export default __webpack_public_path__ + "static/media/scheduler-icon.db48343390e50884ad5ac64465e2fe83.svg";
export { ForwardRef as ReactComponent };